export const storeTypeOptions = [
  { label: 'B2B', value: 'B2B' },
  { label: 'B2C', value: 'B2C' }
];

export const brandMockOptions = [
  { label: 'TREINAMENTO', value: '9999' },
  { label: 'PAPELLO', value: '0001' },
  { label: 'EMPO', value: '0002' },
  { label: 'SITE', value: '0003' },
  { label: 'GELEIA', value: '0010' },
  { label: 'SOHO', value: '0011' },
  { label: 'COCO BAMBU', value: '0012' },
  { label: 'SANTE', value: '0013' },
  { label: 'BEIRUTE', value: '0014' },
  { label: 'POBRE JUAN', value: '0015' },
  { label: 'RICHESSE', value: '0016' },
  { label: 'CHICAGO PRIME', value: '0017' },
  { label: 'CONSAGRADO', value: '0018' },
  { label: 'NONNA AUGUSTA', value: '0019' },
  { label: 'GRAN BIER', value: '0020' },
  { label: 'VASTO', value: '0021' },
  { label: 'AÇAI DO NINJA', value: '0022' },
  { label: 'FRANGO NO POTE', value: '0023' },
  { label: 'MILKY LAB', value: '0024' },
  { label: 'AREA DA PAM', value: '0025' },
  { label: 'FROZEN MIX', value: '0026' },
  { label: 'STONIA', value: '0027' },
  { label: 'MILKY MOO', value: '0028' },
  { label: 'AMERICAN COOKIES', value: '0029' },
  { label: 'DEPYL ACTION', value: '0030' },
  { label: 'DON ROMANO', value: '0031' },
  { label: 'BEACH PARK', value: '0032' },
  { label: 'BIBI SUCOS', value: '0033' },
  { label: 'BSB GRILL', value: '0034' },
  { label: 'BUTIQUIM TIJUCA', value: '0035' },
  { label: 'CALMAC', value: '0036' },
  { label: 'CANTUCCI', value: '0037' },
  { label: 'DF STAR', value: '0038' },
  { label: 'DIADE CAFETERIA', value: '0039' },
  { label: 'ESPAÇO GOURMET', value: '0040' },
  { label: 'JL BRASÍLIA', value: '0041' },
  { label: 'KENNEDY', value: '0042' },
  { label: 'KENNEDY C/RESP', value: '0043' },
  { label: 'KIMUKEKA', value: '0044' },
  { label: 'MEU BEM ALIMENTOS', value: '0045' },
  { label: 'MUCA SHAKE', value: '0046' },
  { label: 'PIZZA NA ROÇA', value: '0047' },
  { label: 'PRIMO PIATO', value: '0048' },
  { label: 'SANTA LUCIA', value: '0049' },
  { label: 'TAYPA', value: '0050' },
  { label: 'VILA CINCO', value: '0051' },
  { label: 'XIQUE XIQUE', value: '0052' },
  { label: 'CASA BACO', value: '0053' },
  { label: 'FIGUEIREDO', value: '0054' },
  { label: 'MANGAI', value: '0055' },
  { label: 'MANZUA', value: '0056' },
  { label: 'MARMITERIA COM AMOR', value: '0057' },
  { label: 'NAU', value: '0058' },
  { label: 'PÃO DOURADO', value: '0059' },
  { label: 'SWEET MELO', value: '0060' },
  { label: 'CAFÉ DO SITIO', value: '0061' },
  { label: 'SPLASH', value: '0062' },
  { label: 'SAGA SADIF', value: '0063' },
  { label: 'LOCALIZA RENT A CAR', value: '0064' },
  { label: 'SENAC CNC', value: '0065' },
  { label: 'SHOPEE', value: '0066' },
  { label: 'DOG DO JUNINHO', value: '0067'}  
];
